import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export const AUTH_STATE_AUTHING = 0
export const AUTH_STATE_NOAUTH = 1
export const AUTH_STATE_AUTHED = 2

export const mutations = {
  authed (state, authed) {
    state.authState = authed ? AUTH_STATE_AUTHED : AUTH_STATE_NOAUTH
  },
  user (state, content) {
    state.user = {
      email: content.email
    }
  },
  userProfile (state, profile) {
    state.user = {
      ...state.user,
      ...profile
    }
  }
}

export const storedState = {
  authState: AUTH_STATE_AUTHING,
  user: {},
  firmware: {
    category: '',
    custom: ''
  }
}

export const store = new Vuex.Store({
  state: storedState,
  mutations,
  strict: process.env.NODE_ENV !== 'production'
})



// WEBPACK FOOTER //
// ./src/store.js